import { render, staticRenderFns } from "./demandUserKeywordList.vue?vue&type=template&id=4a0c796b&scoped=true"
import script from "./demandUserKeywordList.vue?vue&type=script&lang=js"
export * from "./demandUserKeywordList.vue?vue&type=script&lang=js"
import style0 from "./demandUserKeywordList.vue?vue&type=style&index=0&id=4a0c796b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c796b",
  null
  
)

export default component.exports